import PaginationResultsBlock from '@Components/Navigations/PaginationResultsBlock'
import React, { PropsWithChildren, useContext } from 'react'
import PaginationAndLimit from '@Components/Navigations/PaginationAndLimit'
import { PaginationBody } from '@Entities/pagination'
import { observer } from 'mobx-react'
import SongwriterWriterSearchStore from '@App/stores/search/songwriter/songwriter-writer-search-store'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import { useNavigate } from 'react-router'
import { StoresContext } from '@App/contexts'

interface SongwriterCatalogBuilderResults {
    setLoading: (loading: boolean) => void
    songwriterWriterSearchStore: SongwriterWriterSearchStore
}

const SongwriterCatalogBuilderResults = (props: PropsWithChildren<SongwriterCatalogBuilderResults>) => {
    const { setLoading, songwriterWriterSearchStore, children } = props
    const navigate = useNavigate()
    const { songwriterStore } = useContext(StoresContext)
    const count = songwriterWriterSearchStore.totalNumberOfResults

    const onPageChange = async (pagination: PaginationBody) => {
        setLoading(true)
        await songwriterWriterSearchStore.search(pagination).finally(() => setLoading(false))
    }

    const onLimitChange = async (newLimit: number) => {
        setLoading(true)
        await songwriterWriterSearchStore.setPageLimit(newLimit).finally(() => setLoading(false))
    }

    return songwriterWriterSearchStore.hasSearched ? (
        count > 0 ? (
            <div className="writer-search-results">
                <PaginationResultsBlock
                    totalResults={count}
                    workNumTitles={songwriterWriterSearchStore.numTitles}
                    justResults={false}
                    hideNoResults
                />
                {children}
                <Button
                    className="catalog-button-link"
                    mainColor
                    type="primary"
                    onClick={() => navigate(Navigation.songwriter.catalog.root(songwriterStore.currentSongwriterId))}
                >
                    View my catalog
                </Button>
                <PaginationAndLimit
                    paginationInfo={songwriterWriterSearchStore.searchByCriteriaPaginationInfo}
                    onPageChange={onPageChange}
                    onLimitChange={onLimitChange}
                    count={count}
                    limit={songwriterWriterSearchStore.resultsPerPageLimit}
                />
            </div>
        ) : (
            <>No Results Found</>
        )
    ) : (
        <></>
    )
}

export default observer(SongwriterCatalogBuilderResults)
